import axiosInstance from "../config/axiosInstance";

export const updateDealership = async ({
  id,
  businessName,
  gstNumber,
  entityType,
  businessCategory,
  address,
  street,
  city,
  country,
  postalCode,
  businessOverview,
  businessPhotoUrl,
  logoPhotoUrl,
  franchiseFee,
  royalPercentage,
  requiredAreaSqFt,
  supportProvided,
  territoryAvailability,
  minimumInvestmentRequired,
  maximumInvestmentRequired,
  expectedROI,
  loanAssistanceOptions,
  acceptanceOfTermsAndConditions,
  agreementToPrivacyPolicy,
  user,
  plan,
  payment_status,
  status,
  madeBy,
}) => {

      let formdata = new FormData();
      formdata.append("businessName", businessName);
      // formdata.append("gstNumber", gstNumber);
      formdata.append("entityType", entityType);
      formdata.append("businessCategory", businessCategory);
      formdata.append("address", address);
      formdata.append("street", street);
      formdata.append("city", city);
      formdata.append("country", country);
      formdata.append("postalCode", postalCode);
      formdata.append("businessOverview", businessOverview);
      formdata.append("businessPhotoUrl", businessPhotoUrl);
      formdata.append("logoPhotoUrl", logoPhotoUrl);
      formdata.append("franchiseFee", franchiseFee);
      formdata.append("royalPercentage", royalPercentage);
      formdata.append("requiredAreaSqFt", requiredAreaSqFt);
      formdata.append("supportProvided", supportProvided);
      formdata.append("territoryAvailability", territoryAvailability);
      formdata.append("minimumInvestmentRequired", minimumInvestmentRequired);
      formdata.append("maximumInvestmentRequired", maximumInvestmentRequired);
      formdata.append("expectedROI", expectedROI);
      formdata.append("loanAssistanceOptions", loanAssistanceOptions);
      formdata.append(
        "acceptanceOfTermsAndConditions",
        acceptanceOfTermsAndConditions
      );
      formdata.append("agreementToPrivacyPolicy", agreementToPrivacyPolicy);
      formdata.append("user", user);
      formdata.append("plan", plan);
      formdata.append("payment_status", payment_status);
      formdata.append("status", status);
      formdata.append("madeBy", madeBy);

    
      const data = await axiosInstance.put(
        `/api/admin/update/dealership/${id}`,
        formdata,
        {
          "Content-Type": "multipart/form-data",
        }
      );
    return data;

};
export const deleteDealership = async (id) => {
  try {
    const data = await axiosInstance.delete(
      `/api/admin/delete/dealership/${id}`
    );
    return data;
  } catch (error) {
    return error;
  }
};



export const createDealership = async ({
  businessName,
  gstNumber,
  entityType,
  businessCategory,
  address,
  street,
  city,
  country,
  postalCode,
  businessOverview,
  businessPhotoUrl,
  logoPhotoUrl,
  franchiseFee,
  royalPercentage,
  requiredAreaSqFt,
  supportProvided,
  territoryAvailability,
  minimumInvestmentRequired,
  maximumInvestmentRequired,
  expectedROI,
  loanAssistanceOptions,
  acceptanceOfTermsAndConditions,
  agreementToPrivacyPolicy,
  user,
  plan,
  payment_status,
  status,
  madeBy,
}) => {
  let formdata = new FormData();
  formdata.append("businessName", businessName);
  formdata.append("gstNumber", gstNumber);
  formdata.append("entityType", entityType);
  formdata.append("businessCategory", businessCategory);
  formdata.append("address", address);
  formdata.append("street", street);
  formdata.append("city", city);
  formdata.append("country", country);
  formdata.append("postalCode", postalCode);
  formdata.append("businessOverview", businessOverview);
  formdata.append("businessPhotoUrl", businessPhotoUrl);
  formdata.append("logoPhotoUrl", logoPhotoUrl);
  formdata.append("franchiseFee", franchiseFee);
  formdata.append("royalPercentage", royalPercentage);
  formdata.append("requiredAreaSqFt", requiredAreaSqFt);
  formdata.append("supportProvided", supportProvided);
  formdata.append("territoryAvailability", territoryAvailability);
  formdata.append("minimumInvestmentRequired", minimumInvestmentRequired);
  formdata.append("maximumInvestmentRequired", maximumInvestmentRequired);
  formdata.append("expectedROI", expectedROI);
  formdata.append("loanAssistanceOptions", loanAssistanceOptions);
  formdata.append(
    "acceptanceOfTermsAndConditions",
    acceptanceOfTermsAndConditions
  );
  formdata.append("agreementToPrivacyPolicy", agreementToPrivacyPolicy);
  formdata.append("user", user);
  formdata.append("plan", plan);
  formdata.append("payment_status", payment_status);
  formdata.append("status", status);
  formdata.append("madeBy", madeBy);

  const response = await axiosInstance.post(
    "/api/admin/create/createdealership",
    formdata,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response;
};